import React from "react";
import { motion } from "framer-motion";
import { Camera, Zap, Calendar, ArrowRight } from "lucide-react";

const ITEMS = [
  { icon: Camera, title: "Send photos", desc: "Drop your photos and postcode via the quote form, email or WhatsApp." },
  { icon: Zap, title: "Get quick estimate", desc: "Most estimates returned the same day — clear, fixed prices." },
  { icon: Calendar, title: "Flexible scheduling", desc: "We'll agree a date that suits your programme — evenings and weekends if needed." },
];

export default function FreeQuotes() {
  return (
    <section
      id="free-quotes"
      data-testid="free-quotes-section"
      className="bg-[#F5EFE5] text-[#2B2420] py-20 md:py-28 border-y border-[#E5DDD0]"
    >
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-5">
            <span className="brand-gold-divider" /> Free quotations
          </div>
          <h2
            className="font-black tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            We provide free quotes <br /> and site visits.
          </h2>
          <p className="mt-5 text-[#4D4037] text-base md:text-lg leading-relaxed max-w-xl">
            Photos are usually enough. For larger projects we'll arrange a free
            site visit — evenings and weekends included.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`free-quote-item-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-white border border-[#E5DDD0] p-7 md:p-8"
              >
                <div className="w-12 h-12 bg-[#B8732C] flex items-center justify-center text-white">
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                </div>
                <h3
                  className="mt-6 font-black tracking-tight text-xl md:text-2xl leading-tight"
                  style={{ fontFamily: "Cabinet Grotesk" }}
                >
                  {it.title}
                </h3>
                <p className="mt-2 text-sm text-[#8A7F74] leading-relaxed">{it.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-10">
          <a
            href="#quote"
            data-testid="free-quotes-cta"
            className="inline-flex items-center gap-2 bg-[#B8732C] hover:bg-[#9A5D1E] text-white px-6 py-4 text-sm font-bold uppercase tracking-[0.15em] transition-colors"
          >
            Send Photos for Quick Estimate <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
